import { Controller } from '@hotwired/stimulus'

// Disables a submit button until the form is actually submittable: the gating
// checkbox (rules consent) is ticked AND every required field is filled in.
// `required` on the checkbox remains the no-JS fallback.
//
// It used to gate on the checkbox alone, which read as "ticking the box is what
// enables sending" — the button lit up on an otherwise empty form. Validity is
// re-checked on every input, so the button lights up the moment the form is complete.
//
// Forms marked `novalidate` are gated on the checkbox only. That attribute is a
// deliberate statement that the browser is not the one validating this form (the
// manual vacancy form sets it and validates server-side, so its fields report errors
// as field messages, not as a tooltip). Gating on `checkValidity()` there would leave
// the button dead for a reason the page never shows.
export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect () {
    this.boundToggle = this.toggle.bind(this)
    this.element.addEventListener('input', this.boundToggle)
    this.element.addEventListener('change', this.boundToggle)
    this.toggle()
  }

  disconnect () {
    this.element.removeEventListener('input', this.boundToggle)
    this.element.removeEventListener('change', this.boundToggle)
  }

  toggle () {
    const consented = !this.hasCheckboxTarget || this.checkboxTarget.checked
    const ready = consented && this.formIsValid()

    this.submitTargets.forEach((button) => { button.disabled = !ready })
  }

  formIsValid () {
    const form = this.element.tagName === 'FORM'
      ? this.element
      : this.element.querySelector('form')

    if (form === null || typeof form.checkValidity !== 'function') return true
    if (form.noValidate) return true

    return form.checkValidity()
  }
}
